export default {
  methods: {

    set_LocalValues(){

      // DataItems
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.sql1 = this.Queries.SQL1[0]

      // Json
      let json = JSON.parse(JSON.stringify(this.JQueries))
      this.title    = json.title
      this.table    = json.table
      this.columns  = json.columns

      this.sundries = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters

      this.gmx_tableCoordinates('x', this.columns, 3)
      this.table.width = this.columns[this.columns.length-1].ex

      this.table.height = this.table.lineHeight * (this.rawData.length) + this.table.headHeight

      this.punch.PA = this.gmx_maxBound5(Math.max(...this.rawData.map(item => item.PA_TOT)))
      this.punch.PB = this.gmx_maxBound5(Math.max(...this.rawData.map(item => item.PB_TOT)))

    },

  }
}